export default __webpack_public_path__ + "static/media/about-benefits-listing-detail-page.54724d24.jpg";